exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.income-by-field {\n    max-height: 300px;\n}\n", ""]);

// exports
